import React from 'react';
import { StickyHeader } from './components/StickyHeader';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { DiscoverySection } from './components/DiscoverySection';
import { ProductSection } from './components/ProductSection';
import { BenefitsSection } from './components/BenefitsSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-blue-200" data-id="element-0">
      <StickyHeader data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <DiscoverySection data-id="element-5" />
        <ProductSection data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <HowItWorksSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <OfferSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <FinalCTASection data-id="element-13" />
      </main>

      <Footer data-id="element-14" />
      <StickyMobileCTA data-id="element-15" />
    </div>;
}